import { trackEvent } from 'src/lib/googleAnalytics';
import { t } from 'src/lib/player/i18n';
import { type EventState, useStore } from 'src/lib/player/store';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { POI_HEIGHT, POI_WIDTH } from '../Map/MarkerContext';
import { SelectionControls } from './SelectionControls';

type Props = {
  event: EventState;
};

const CDN_HOST = import.meta.env.VITE_CDN_HOST;

export default function EventListItem({ event }: Props): JSX.Element {
  const isSelected = useStore((state) => state.currentEventIndices.includes(event.index));
  const isLive = Date.now() >= event.startTime && event.endTime >= Date.now();
  const toggleSelectedEvent = useStore((state) => state.actions.toggleSelectedEvent);

  function handleClick() {
    trackEvent('select_content', { content_type: 'event', selected: !isSelected });
    toggleSelectedEvent(event.index);
  }

  return (
    <div
      className="starter-list-item starter-list-item-with-hover"
      {...onClickGenerator(handleClick)}
    >
      <div style={{ opacity: isSelected ? 1 : 0.5 }}>
        <div className="starter-text">
          <div className="starter-name" title={event.name}>
            <img
              src={`${CDN_HOST}/api/events/${event.eventId}/logo`}
              style={{ width: POI_WIDTH * 0.5, height: POI_HEIGHT * 0.5 }}
              alt="Event Logo"
            />
            &nbsp;
            <div className="starter-name-content">{event.shortName}</div>
            {isLive && <div className="badge">{t('LIVE')}</div>}
          </div>
        </div>
        <SelectionControls isVisible={isSelected} />
      </div>
    </div>
  );
}
